import templateSlideReview from './templateSlideReview';
import { dateFormatted, webflowRestart } from './utils';

const getCustomerName = (firstName, lastName) => {
  const name = firstName === 'Previous Customer' ? 'John' : firstName;

  return `${name ?? ''} ${lastName ?? ''}`;
};

const buildReviews = (reviews) =>
  reviews
    .map((reviewItem) => {
      const { first_name: customerFirstName, last_name: customerLastName, content, date, avatar, service } = reviewItem;
      const name = getCustomerName(customerFirstName, customerLastName);
      const dateToDDMMYY = dateFormatted(date);

      return templateSlideReview(name, content, dateToDDMMYY, avatar, service);
    })
    .join('');

const renderReviews = (reviews, elements) => {
  const { maskMainSlide } = elements;

  if (!maskMainSlide) {
    return false;
  }

  const htmlReviews = buildReviews(reviews);

  maskMainSlide.innerHTML = '';

  maskMainSlide.insertAdjacentHTML('beforeend', htmlReviews);
  webflowRestart();

  return true;
};

const render = (state, elements) => (path, value) => {
  switch (path) {
    case 'reviews':
      renderReviews(value, elements);
      break;

    default:
      break;
  }
};

export default render;
